import React, {useContext, useEffect, useState} from 'react';
import './Footer.scss'


//page for the left menu
function Footer() {


    return(
        <>
            <div className="footerMainDiv">
                <div>
                    <p className="footerTitle">Explore</p>
                    <a className="footerLink" href="https://www.akts.com/" target="_blank">Other software</a>
                </div>
                <div>
                    <p className="footerTitle">Contact</p>
                    <a className="footerLink" href="https://www.akts.com/about-us/" target="_blank">About Us</a>
                    <a className="footerLink" href="https://www.akts.com/contact-us/" target="_blank">Contact Us</a>
                </div>
                <div>
                    <p className="footerTitle">AKTS SA</p>
                    <p className="footerNoPointer">Swiss Digital Center</p>
                    <p className="footerNoPointer">Technopôle 1</p>
                    <p className="footerNoPointer">3960 Sierre</p>
                    <p className="footerNoPointer">Swizerland</p>
                </div>
                <div>
                    <p className="footerNoPointer">+41-848 800 221</p>
                    <p className="footerTitle">info@akts.com</p>
                    <p className="footerTitle">support@akts.com</p>
                    <p className="footerTitle">sales@akts.com</p>
                </div>
                <div>
                    <p className="footerTitle">Legal</p>
                    <a className="footerLink" href="https://www.akts.com/privacy-policy/" target="_blank">Privacy Policy</a>
                    <a className="footerLink" href="https://www.akts.com/privacy-policy/" target="_blank">We use cookies to provide a </a>
                    <a className="footerLink" href="https://www.akts.com/privacy-policy/" target="_blank">better web experience. By using </a>
                    <a className="footerLink" href="https://www.akts.com/privacy-policy/" target="_blank">our site, you acknowledge the </a>
                    <a className="footerLink" href="https://www.akts.com/privacy-policy/" target="_blank">use of cookies.</a>
                </div>
            </div>
        </>
    )
}

export default Footer;